import React     from 'react'
import PropTypes from 'prop-types'

import ActionButton from '../components/ActionButton'

import api from '../redux/api'

export default class FailButton extends React.Component {
  static propTypes = {
    job:     PropTypes.object.isRequired,
    history: PropTypes.object.isRequired,    
  }

  handleFail = () => {
    return api.failJob({ jobId: this.props.job.id })
  }

  handleFailComplete = (result) => {
    this.props.history.push(`/jobs/item/${result.jobId}`)
  }
  
  render() {
    const { job } = this.props

    const title  = job.title
      ? `Are you sure to fail "${job.title}" job?`
      : 'Are you sure to fail the job?'

    return (
      <ActionButton
        buttonColor={"#e33a30c4"}
        buttonIconName="times circle"
        buttonText="Fail"
        onPerformAction={this.handleFail}
        onPerformActionComplete={this.handleFailComplete}
        confirmationTitle={title}
        confirmationHeader="Fail job"
      />
    )
  }
}
